exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".index__dataMap___2HW3W{position:relative;display:block}", ""]);

// exports
exports.locals = {
	"dataMap": "index__dataMap___2HW3W"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./app/components/datamap/index.css
// module id = 315
// module chunks = 1